import { createAsyncType } from '@/store/utils/mutation-types'

export const types = {
  RESET: 'RESET',
  GET_LIST: createAsyncType('GET_LIST')
}

const SET_PAGINATION = 'SET_PAGINATION'
const RESET_PAGINATION = 'RESET_PAGINATION'

const PAGINATION_CURRENT_PAGE = 1
const PAGINATION_PER_PAGE = 10
const PAGINATION_TOTAL = 0

export const createPagination = (options = {}) => ({
  namespaced: true,

  state: {
    items: [],
    loading: false,
    descending: false,
    sortBy: null,
    currentPage: PAGINATION_CURRENT_PAGE,
    perPage: options.perPage || PAGINATION_PER_PAGE,
    total: PAGINATION_TOTAL
  },

  mutations: {
    [SET_PAGINATION] (state, payload) {
      state.currentPage = parseInt(payload.currentPage, 10)
      state.perPage = parseInt(payload.perPage, 10)
      state.total = parseInt(payload.total, 10)
      state.items = payload.items || []
    },
    [RESET_PAGINATION] (state) {
      state.currentPage = PAGINATION_CURRENT_PAGE
      state.perPage = PAGINATION_PER_PAGE
      state.total = PAGINATION_TOTAL
    },
    [types.GET_LIST.REQUEST] (state, params) {
      state.loading = true
      state.currentPage = params.page
    },
    [types.GET_LIST.SUCCESS] (state, result) {
      state.items = result.data.items
      state.total = result.data.total
      state.loading = false
    },
    [types.GET_LIST.FAILURE] (state) {
      state.loading = false
    }
  },

  actions: {
    paginate (context, payload) {
      context.commit(SET_PAGINATION, payload)
    },

    resetPaginator (context) {
      context.commit(RESET_PAGINATION)
    }
  }
})
